import React from "react";
import PmsThemeSettingsPanel from "../../Components/PmsThemeSettingsPanel";

export default function Settings() {
  return (
    <main className="crm-page crm-page--settings">
      <PmsThemeSettingsPanel />
    </main>
  );
}
